import React from "react";
import StudentDash from "../../Components/StudentComponents/StudentDash/StudentDash";
import JobPost from "../../Components/StudentComponents/JobPost/JobPost";

function JobPostPage() {
  return (
    <StudentDash>
      <JobPost />
    </StudentDash>
  );
}

export default JobPostPage;
